(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/authenticate/assets/javascripts/utils/process-utils.js') >= 0) return;  svs.modules.push('/components/accountservices/authenticate/assets/javascripts/utils/process-utils.js');

'use strict';

const {
  LoginMethods,
  LoginTypes,
  CONFIG
} = svs.accountservices.authenticate.definitions;
function createNewProcess() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const newProcess = {
    ssn: options.ssn,
    qr: Boolean(options.qr),
    isBankID: !options.method || options.method !== LoginMethods.FREJA,
    codeChallenge: options.codeChallenge,
    retryPoll: Boolean(options.qr),
    remainingRetries: 0,
    loginToken: options.loginToken,
    loginTokenTs: options.tokenTimestamp,
    timeoutType: options.timeoutType,
    pollStatus: 0,
    isSign: Boolean(options.isSign),
    completed: false,
    codeChallengeMethod: options.codeChallengeMethod,
    ltFrServerSide: Boolean(options.loginToken),
    isCustomerRegistration: Boolean(options.isCustomerRegistration),
    cancelled: false,
    cancelInProgress: false,
    isPoker: options.isPoker
  };
  if (newProcess.qr) {
    if (newProcess.isBankID) {
      newProcess.remainingRetries = CONFIG.QR_TIMEOUT_RETRIES.BANKID;
    } else {
      newProcess.remainingRetries = CONFIG.QR_TIMEOUT_RETRIES.FREJA;
    }
  }
  return newProcess;
}
function isSameProcessType(processA, processB) {
  return Boolean(processA && processB && Boolean(processA.ssn) === Boolean(processB.ssn) && (processA.ssn && processB.ssn ? processA.ssn === processB.ssn : true) && processA.isBankID === processB.isBankID && processA.qr === processB.qr && Boolean(processA.codeChallenge) === Boolean(processB.codeChallenge));
}
function processHasLoginMethod(process) {
  let loginMethod = '';
  if (svs.core.detect.formfactor.mobile()) {
    if (process !== null && process !== void 0 && process.isBankID) {
      loginMethod = LoginTypes.MOBILE_BANKID;
    } else {
      loginMethod = LoginTypes.MOBILE_FREJA;
    }
  } else if (process !== null && process !== void 0 && process.isBankID) {
    if (process.qr) {
      loginMethod = LoginTypes.DESKTOP_BANKID_MOBILE_QR;
    } else if (process.ssn) {
      loginMethod = LoginTypes.DESKTOP_BANKID_MOBILE_SSN;
    } else {
      loginMethod = LoginTypes.DESKTOP_BANKID;
    }
  } else if (process.qr) {
    loginMethod = LoginTypes.DESKTOP_FREJA;
  } else {
    loginMethod = LoginTypes.DESKTOP_FREJA_SAME_DEVICE;
  }
  return loginMethod;
}
svs.accountservices.authenticate.utils.process = {
  createNewProcess,
  isSameProcessType,
  processHasLoginMethod
};

 })(window);